<!--<div class="wizard-free-trial">-->
<!--  <div class="trial-title">EVERYTHING YOU NEED TO MANAGE YOUR RENTAL AND REPAIR OPERATIONS.</div>-->
<!--  <div class="trial-blurb">Submit your details below for a 7-day full-access trial of our software. Experience-->
<!--    firsthand why so many shops globally trust Hubtiger to enhance their rental and repair shop operations.-->
<!--  </div>-->
<!--</div>-->

<div *ngIf="!registered" class="wizard-inner-container">
  <div class="wizard-registration-title">{{'onboarding.titles.bike_shop_registration' | translate}}</div>
  <div class="wizard-registration-subtitle">No software installs. No cards. Simple access.</div>
  <div class="wizard-form">
    <form (ngSubmit)="registerShop()" [formGroup]="RegistrationForm">
      <div class="row margin-top-32">
        <div class="col-md-12">
          <div class="input-group">
            <input
              [ngClass]="{ 'invalid-input': RegistrationForm.get('BikeShopName')?.invalid && RegistrationForm.get('BikeShopName')?.touched }"
              class="sign-up-input" formControlName="BikeShopName" id="BikeShopName"
              placeholder="{{ 'onboarding.bike_shop_name' | translate}}"
              type="text"
            />
            <!--            <label for="BikeShopName">{{ 'onboarding.bike_shop_name' | translate}}</label>-->
          </div>
        </div>
      </div>
      <!--      todo (dcorbett) removed {{Country}}-->
      <div class="row margin-top-32">
        <div class="col-md-12">
          <div class="input-group">
            <p-dropdown (onChange)="onCountrySelected()" [options]="countries" class="w-100 country-dropdown "
                        formControlName="Country" id="Country"
                        optionLabel="label"
                        placeholder="{{ 'onboarding.country' | translate}}">
            </p-dropdown>
            <!--            <label for="Country">{{ 'onboarding.country' | translate}}</label>-->
          </div>
        </div>
      </div>
      <div class="row margin-top-32">
        <div class="col-md-12">
          <div class="input-group">
            <input
              [ngClass]="{ 'invalid-input': RegistrationForm.get('CustomerName')?.invalid && RegistrationForm.get('CustomerName')?.touched }"
              class="sign-up-input" formControlName="CustomerName"
              id="CustomerName"
              placeholder="{{ 'onboarding.first_name_surname' | translate}}"
              type="text"/>
            <!--            <label for="CustomerName">{{ 'onboarding.first_name_surname' | translate}}</label>-->
          </div>
        </div>
      </div>
      <div class="row margin-top-32">
        <div class="col-md-12">
          <div class="input-group">
            <input (blur)="validDomain()"
                   [ngClass]="{ 'invalid-input': RegistrationForm.get('Email')?.invalid && RegistrationForm.get('Email')?.touched }"
                   class="sign-up-input" formControlName="Email"
                   id="Email"
                   placeholder="{{ 'onboarding.email' | translate}}"
                   type="email"/>
            <!--            <label for="Email">{{ 'onboarding.email' | translate}}</label>-->
          </div>
        </div>
        <div *ngIf="isInvalidDomain" class="col-md-12">
          <div class="">
            <label style="color: #EE3158">Invalid domain</label>
          </div>
        </div>
      </div>
      <div class="row margin-top-32">
        <div class="col-md-12">
          <div class="input-group">
            <input
              [ngClass]="{ 'invalid-input': RegistrationForm.get('PhoneNumber')?.invalid && RegistrationForm.get('PhoneNumber')?.touched }"
              class="sign-up-input" formControlName="PhoneNumber"
              id="PhoneNumber"
              placeholder="{{ 'onboarding.mobilenumber' | translate}}"
              type="text"/>
            <!--            <label for="PhoneNumber">{{ 'onboarding.mobilenumber' | translate}}</label>-->
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 wizard-product-selection">
          <div class="label text-light">{{ 'onboarding.select_product' | translate}}:</div>
          <div [ngClass]="{ 'invalid-input': !productSelected() && RegistrationForm.get('Workshop')?.touched }"
               class="selection-container">
            <div>
              <p-checkbox [binary]="true" formControlName="Workshop" pInputText></p-checkbox>
              <div class="text-light">{{'onboarding.workshop' | translate}}</div>
            </div>
            <div>
              <p-checkbox [binary]="true" formControlName="Rentals" pInputText></p-checkbox>
              <div class="text-light">{{'onboarding.rentals' | translate}}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="row store-type-selector">
        <div class="col-md-12 label text-light">
          {{ 'onboarding.store_type' | translate }}:
        </div>
        <div class="col-md-12">
          <div class="p-inputgroup">
            <p-dropdown [options]="partnerTypes" class="country-dropdown" formControlName="PartnerType">
            </p-dropdown>
          </div>
        </div>
      </div>


      <div class="row my-2">
        <div class="col-md-12 submit-container">
          <button
            class="mt-2 iso-round-button iso-secondary w-100"
            type="submit">{{registering ?
            ('onboarding.button.please_wait' | translate) : ('onboarding.button.register_bikeshop' | translate
            )}}</button>
        </div>
      </div>

      <div *ngIf="!registered && message" class="wizard-message fail center margin-top-32">
        <div [innerHTML]="message"></div>
      </div>

    </form>
  </div>
</div>

<div *ngIf="registered" class="wizard-inner-container">
  <div class="wizard-registration-title">{{'onboarding.titles.email_verification_required' | translate}}</div>
  <div class="hubtiger-mail margin-top-16"></div>
  <div [innerHTML]="message" class="wizard-registration-message margin-top-16 text-light"></div>
</div>
